import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AboutusService } from 'src/services/aboutus.service';
import { CanonicalService } from '../../services/canonical.service';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { Carousel } from 'primeng/carousel';
import { forkJoin } from 'rxjs';
import { Meta } from '@angular/platform-browser';
@Component({
  selector: 'aboutus',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class AboutUsComponent implements OnInit {
  // #docregion property declaration
  public title: string;
  public aboutUsDetails: any = { bannerImage: null, bannerTitle: null, content: null };
  public imagesList: any;
  public responsiveOptions: any;
  public cultureDetails: any = [];
  public climateDetails: any = [];
  public geographyDetails: any = [];
  public historyDetails: any = [];
  public societyDetails: any = [];
  public aboutUsDetailsList: any;
  public cultureDetailsList: any;
  public societyDetailsList: any;
  public carousel: boolean;
  public artDetails: any = [];
  public sociatyDetails: any = [];
  public aboutRefList: any = [];
  public culRefList: any = [];
  public socityRefList: any = [];
  aboutUsInfoData: any = { bannerTitle: null, bannerImage: null, content: null };
  bannerImage: any;
  aboutItemsLength: number;
  index = 0;
  activeState: any = [];
  activeIndex: any;
  displayCustom: boolean;
  images: any = [];
  // #enddocregion property declaration

  /**
   * constructor
   * @param route
   * @param router
   * @param aboutusService
   * @param messageService
   * @param confirmationService
   */
  constructor(
    public route: ActivatedRoute,
    private router: Router,
    public aboutusService: AboutusService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private meta: Meta,
    private canonicalService: CanonicalService
  ) {
    //The touchmove event is fired when the user moves the finger across the screen.
    Carousel.prototype.onTouchMove = () => {};
    //Bind Responsive Options for Carousel with no of visibile images,scroll with respecive to size of device
    this.responsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 1,
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '640px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '480px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
  }

  ngOnInit(): void {
    //ngOnInit method
    //fetching query parameters
    this.canonicalService.createCanonicalURL();
    this.meta.updateTag({
      name: 'description',
      content: 'Seychelles lies northeast of Madagascar, an archipelago of 115 islands with roughly 98,000 citizens.',
    });
    this.route.paramMap.subscribe((paramMap) => {
      this.title = paramMap.get('selectedPage');
      if (this.title == 'aboutseychelles') {
        this.getAboutUs();
        // this.getCulture();
        // this.getClimate();
        // this.getGeoGraphy();
        // this.getHistory();
        // this.getSociety();

        this.getAboutUsDetails('about-us');
      } else if (this.title == 'culture' || this.title == 'Culture') {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
          this.router.navigate(['/about-us-items'], {
            queryParams: { selectedPage: this.title },
          })
        );
      } else if (this.title == 'society' || this.title == 'Society') {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
          this.router.navigate(['/about-us-items'], {
            queryParams: { selectedPage: this.title },
          })
        );
      } else {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
          this.router.navigate(['/about-us-detail'], {
            queryParams: { selectedPage: this.title },
          })
        );
      }
    });
    this.getDetailsOfPage('culture', this.index);
    this.activeState[0] = true;
  }

  ngAfterContentChecked() {
    var elem = document.getElementById('' + this.index);
    if (elem) {
      elem.classList.add('active');
    }
  }

  /**
   * getAboutUsDetails
   * get details of selected page
   * @param selectedValue
   */
  getAboutUsDetails(selectedValue: any) {
    this.aboutusService.getAboutUsDetails(selectedValue).subscribe(
      (data) => {
        this.aboutUsDetails = data;
        this.images.push(this.aboutUsDetails.bannerImage);
      },
      (err) => {
        this.messageService.add({ severity: 'error', summary: err.message, detail: '' });
      }
    );
  }

  getDetailsOfPage(selectedValue: any, index: any) {
    this.index = index;
    for (var i = 0; i < this.aboutItemsLength; i++) {
      document.getElementById('' + i).classList.remove('active');

      //  element.classList.remove("active");
    }

    // document.getElementById(index).classList.add("active");
    //get deatils of selected page(fetched from query params)
    this.aboutusService.getAboutUsDetails(selectedValue).subscribe((aboutUsInfo) => {
      if (aboutUsInfo) {
        this.aboutUsInfoData = aboutUsInfo;
        if (aboutUsInfo.bannerImage) {
          this.bannerImage = aboutUsInfo.bannerImage;
        } else {
          this.bannerImage = '../../../assets/images/NoImage.jpg';
        }
      }
    });
    // setTimeout(()=>{

    // },2000)
  }
  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }

  /**
   * get details-page while clicking on the image in the caurosel and redirecting to respeced pages according to data
   * @param selectedValue
   */
  getDetails(selectedValue: any) {
    if (selectedValue == 'culture' || selectedValue == 'Culture') {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['/about-us-items'], {
          queryParams: { selectedPage: selectedValue },
        })
      );
    } else if (selectedValue == 'Society' || selectedValue == 'society') {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['/about-us-items'], {
          queryParams: { selectedPage: selectedValue },
        })
      );
    } else {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['/about-us-detail'], {
          queryParams: { selectedPage: selectedValue },
        })
      );
    }
  }

  /**
   * get culture details
   */
  getCulture() {
    // let culdetails = {};
    this.aboutusService.getCultureDetails().subscribe(
      (data) => {
        // culdetails = data;
        this.cultureDetails.push(data);
        //this.aboutUsDetailsList = this.cultureDetails;
      },
      (err) => {
        this.messageService.add({ severity: 'error', summary: err.message, detail: '' });
      }
    );
  }

  /**
   * get Climate Details
   */
  getClimate() {
    this.aboutusService.getclimateDetails().subscribe(
      (data) => {
        this.cultureDetails.push(data);
        // this.aboutUsDetailsList = this.cultureDetails;
      },
      (err) => {
        this.messageService.add({ severity: 'error', summary: err.message, detail: '' });
      }
    );
  }

  /**
   * get GeoGraphy Details
   */
  getGeoGraphy() {
    this.aboutusService.getgeographyDetails().subscribe(
      (data) => {
        this.cultureDetails.push(data);
        //this.aboutUsDetailsList = this.cultureDetails;
      },
      (err) => {
        this.messageService.add({ severity: 'error', summary: err.message, detail: '' });
      }
    );
  }

  /**
   * get History Details
   */
  getHistory() {
    this.aboutusService.gethistoryDetails().subscribe(
      (data) => {
        this.cultureDetails.push(data);
        // this.aboutUsDetailsList = this.cultureDetails;
      },
      (err) => {
        this.messageService.add({ severity: 'error', summary: err.message, detail: '' });
      }
    );
  }

  /**
   * get Society Details
   */
  getSociety() {
    this.aboutusService.getsocietyDetails().subscribe(
      (data) => {
        this.cultureDetails.push(data);
        // this.aboutRefList = this.cultureDetails;
        this.aboutUsDetailsList = this.cultureDetails;
      },
      (err) => {
        this.messageService.add({ severity: 'error', summary: err.message, detail: '' });
      }
    );
  }

  getAboutUs() {
    let cultureDetails = this.aboutusService.getCultureDetails();
    let climateDetails = this.aboutusService.getclimateDetails();
    let geographyDetails = this.aboutusService.getgeographyDetails();
    let historyDetails = this.aboutusService.gethistoryDetails();
    let societyDetails = this.aboutusService.getsocietyDetails();
    forkJoin([cultureDetails, climateDetails, geographyDetails, historyDetails, societyDetails]).subscribe(
      (results) => {
        if (results.length > 0) {
          this.aboutUsDetailsList = results;
          this.aboutItemsLength = results.length;
        }
      },
      (err) => {
        this.messageService.add({ severity: 'error', summary: err.message, detail: '' });
      }
    );
    var elem = document.getElementById('' + 0);
    if (elem) {
      elem.classList.add('active');
    }
  }
  onTabClose(event: any) {
    this.activeState[event.index] = !this.activeState[event.index];
  }

  onTabOpen(event: any) {
    this.activeState[event.index] = !this.activeState[event.index];
  }
}
